import { AbsoluteCenter, Spinner } from '@chakra-ui/react';
import { forwardRef } from 'react';

import classNames from 'classnames/bind';
import { Show } from 'shared';

import { styles } from 'features/chat/components';

import { ChatMessageFailureState } from './index';

const cx = classNames.bind(styles);

type ChatMessagesContainerProps = {
  children: React.ReactNode;
  showLoader: boolean;
  hasFailedMessages: boolean;
};

export const ChatMessagesContainer = forwardRef<
  HTMLDivElement,
  ChatMessagesContainerProps
>(({ children, showLoader, hasFailedMessages }, chatRef) => {
  return (
    <div
      ref={chatRef}
      className={cx('chat__messages-wrap')}
      data-testid="chat-messages"
    >
      <Show when={showLoader}>
        <AbsoluteCenter axis="horizontal" w="full" top={2}>
          <Spinner size="md" />
        </AbsoluteCenter>
      </Show>
      {children}
      {hasFailedMessages && <ChatMessageFailureState />}
    </div>
  );
});
